/**
 * عناصر التنقّل الموحّدة — مصدر واحد للقائمة الجانبية والصفحة الرئيسية.
 *
 * القائمة واحدة لكل المستخدمين (مدير، مشرف، مهندس، مقاول، موظف حضور…)؛ ما يظهر منها
 * يحدده شرط المسار في permissions/registry.js (canOpen) لا نوع الحساب. فلا Layout
 * ولا قائمة خاصة بنوع مستخدم.
 */
import { canOpen } from "../permissions/registry";

import { SECTIONS, SYSTEM_ACTIONS } from "./actionRegistry";

/**
 * تحديث 60: العناصر والمجموعات تُشتق من سجل الإجراءات المركزي (actionRegistry.js) — لا قوائم مكررة.
 * الشكل القديم (id/icon/name/nameEn/link/desc) محفوظ لكل من يستعمله (القائمة الجانبية والرئيسية).
 */
export const NAV_ITEMS = SYSTEM_ACTIONS.filter((a) => a.placements.includes("sidebar") || a.placements.includes("dashboard") || a.id === "profile")
  .map((a) => ({ id: a.id, icon: a.icon, name: a.title, nameEn: a.titleEn, link: a.route, desc: a.desc, section: a.section, order: a.order, sidebar: a.placements.includes("sidebar") }));

/** المجموعات بالترتيب المعتمد: كل مجموعة تظهر فقط إن بقي فيها عنصر مسموح. */
export const NAV_GROUPS = SECTIONS.map((sec) => ({
  key: sec.key, title: sec.title, titleEn: sec.titleEn, icon: sec.icon,
  ids: NAV_ITEMS.filter((i) => i.section === sec.key && i.sidebar).sort((x, y) => x.order - y.order).map((i) => i.id),
})).filter((g) => g.ids.length > 0);

const byId = Object.fromEntries(NAV_ITEMS.map((i) => [i.id, i]));

/** العناصر المسموحة للمستخدم الحالي (نفس شرط حماية المسار). */
export function allowedNav() {
  return NAV_ITEMS.filter((i) => canOpen(i.link));
}

/** المجموعات بعناصرها المسموحة فقط. */
export function allowedGroups() {
  return NAV_GROUPS
    .map((g) => ({ ...g, items: g.ids.map((id) => byId[id]).filter((i) => i && canOpen(i.link)) }))
    .filter((g) => g.items.length > 0);
}

/** المجموعة التي تحوي المسار الحالي (لفتحها تلقائياً). */
export function groupOf(pathname) {
  const clean = String(pathname || "").split("?")[0];
  const base = (l) => String(l || "").split("?")[0];
  const g = NAV_GROUPS.find((grp) => grp.ids.some((id) => byId[id] && (clean === base(byId[id].link) || clean.startsWith(base(byId[id].link) + "/"))));
  return g ? g.key : null;
}

export const navItem = (id) => byId[id];
